// extracted by mini-css-extract-plugin
export var caretAnchor = "_vx-0";
export var dropdownContent = "_vx-1";